<template>
  <b-container class="my-3">
    <b-row>
      <b-col cols="12">
        <h1 class="display-4 text-purple">Políticas de Reembolso y Garantía</h1>
        <p class="lead">Todos nuestros productos son elaborados con materíales cuidadosamente seleccionados y bajo el más extricto cuidado. Sin embargo, en ocasiones muy esporádicas puede haber daños no detectados en el proceso de elaboración que compromentan su calidad. Es por eso que todos nuestros productos cuentan con una garatía limitada de 90 días a partir de la fecha de recepción.</p>
        <p class="lead">En tales casos la garantía solo cubrirá fallas de fábrica y/o mano de obra y sólo se hará efectiva cuando el producto se haya usado correctamente. La garantía no cubre averías o daños ocasionados por uso indebido. Los términos de la garantía están asociados a fallas de fabricación y uso en condiciones normales de los productos y sólo se harán efectivos estos términos si el equipo ha sido usado correctamente. Esto incluye:</p>
        <ul class="lead">
          <li>De acuerdo a las especificaciones de uso y cuidado indicadas para cada producto.</li>
          <li>En condiciones ambientales acorde con las especificaciones indicadas por el fabricante.</li>
          <li>En uso específico para la función con que fue diseñado de fábrica.</li>
        </ul>
        <p class="lead">Para hacer válida su garantía pongase en contacto con nosotros por medio del formulario de contacto indicando brevemente el desperfecto en su producto y su número de orden de compra.</p>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
export default {
  name: 'Warranty',
  data () {
    return {}
  }
}
</script>
